import { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Container from './../../components/Layout/Container';
import PageTopBanner from './../../components/PageTopBanner';

import { TabsLink } from './../../components/Tab/Tabs';
import { communityData } from './../../components/Tab/TabData';

import Pagination from 'react-js-pagination';
import useScreenSize from './../../hooks/useScreenSize';

import Input, { onEnter } from '../../components/TextField/Input';
import Table from '../../components/Table/Table';

import Modal, { useToggleModal } from '../../components/Modal/Modal';
import { fetchGet } from '../../hooks/fetch';
import { NoCon } from '../../hooks/NoCon';
import { DownloadLink } from '../../utils/DownloadFunctions';
import { TableLoading } from '../Loading';

export default function Archive() {
	const [isLoading, setIsLoading] = useState(true);
	const [activeTab, setActiveTab] = useState('');
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();

	const handleDataFromChild = (data) => {
		setActiveTab(data);
	};
	const [posts, setPosts] = useState([]); // 전체 게시글 데이터
	const [pagingInfo, setPagingInfo] = useState({});
	const [searchText, setSearchText] = useState(searchParams.get("searchText") === "undefined" ? "" : searchParams.get("searchText") ?? "");

	const [mdFiles, setMdFiles] = useState([]);

	const [page, setPage] = useState(Number.isNaN(Number(searchParams.get("page"))) ? 1 : Number(searchParams.get("page") ?? 1)); // 현재 페이지 번호

	// th 총 갯수 (등록된 내용이 없는 경우 병합)
	const columnRef = useRef(null);
	const [columnSize, setColumnSize] = useState(5);

	const handlePageChange = (page) => {
		setPage(page);
	};

	const screenSize = useScreenSize();

	function getPage() {
		fetchGet(
			`/archive?page=${page}&searchText=${searchText}`,
			(json) => {
				setPosts(json.dataList);
				setPagingInfo(json.pagingInfo);
				setIsLoading(false);
			}
		)
	}

	function search() {
		setSearchParams({
				page: page,
				searchText: searchText,
			},
			{ replace: true }
		);
	}

	useEffect(() => {
		search();
		setIsLoading(true);
		getPage();
	}, [page, searchText]);

	const pageName = '자료실';
	const toggleModal = useToggleModal();

	const handleFileDownload = (e, uid) => {
		e.stopPropagation();

		fetchGet(
			`/file/list?type=ARCHIVE&id=${uid}`,
			(json) => setMdFiles(json.files)
		)

		toggleModal.open({ name: "file-download-dialog" });
	};

	return (
		<main id="community-page-wrap">
			<h1 className="sr-only">{`${pageName} 목록 페이지`}</h1>

			<PageTopBanner />

			<Container>
				<TabsLink
					className="sub-page-tab-con"
					tabsData={communityData}
					activatedTab={activeTab}
					onTabChange={handleDataFromChild}
				/>

				<div className="page-content">
					<div className="content-top">
						<div>
							<h1 className="title">{pageName}</h1>
						</div>
					</div>

					<div>
						<div className="gs-total-search">
							<div className="search">
								<Input
									id="total-search-input"
									type="search"
									label="검색어를 입력해주세요."
									placeholder="검색어 입력"
									value={searchText}
									maxLength={15}
									onChange={(e) => { setSearchText(e.target.value); setPage(1); }}
									onKeyDown={(e) => onEnter(e, () => {search();getPage();})}
								/>
								<button type="submit" onClick={() => {search(); getPage(); }}>
									<span className="sr-only">검색하기</span>
								</button>
							</div>
						</div>

						<Table
							caption="자료실 목록입니다. 번호, 구분, 제목, 첨부파일 여부, 작성자, 작성일을 제공합니다."
							className="hover notice-table-con"
							responsive="960"
						>
							<colgroup>
								<col style={{ width: '100px' }} />
								<col />
								<col style={{ width: '90px' }} />
								<col style={{ width: '100px' }} />
								<col style={{ width: '160px' }} />
							</colgroup>
							<thead>
								<tr ref={columnRef}>
									<th><strong>NO</strong></th>
									<th><strong>제 목</strong></th>
									<th><strong>첨부파일</strong></th>
									<th><strong>작성자</strong></th>
									<th><strong>작성일</strong></th>
								</tr>
							</thead>
							<tbody className="center">
								{isLoading 
									? <TableLoading col={columnSize} />
									: posts?.length === 0 && <NoCon col={columnSize} />}


								{posts?.length > 0 &&
									posts?.map((post) => (
										<tr
											key={post.uid}
											onClick={() => navigate(`./../archive/${post.uid}`, { state: { page: page, searchText: searchText } })}
										>
											<td data-th="NO">
												{post?.rowId == null 
													? <i className="gs-icon-pin"></i>
													: post.rowId
												}
											</td>
											<td data-th="제목" className="ta-left">
												<div className="gs-ellipsis">
													<button
														className="gs-underline-item effect"
														title={post.title}
													>
														<span className="line">{post.title}</span>
													</button>
												</div>
											</td>
											<td data-th="첨부파일">
												{post?.attachedFileYn === 'Y' && (
													<button
														type="button"
														onClick={(e) => handleFileDownload(e, post?.uid)}
														className="gs-icon-file-download"
														title="파일 다운로드"
													>
														<span className="sr-only">파일 다운로드</span>
													</button>
												)}
											</td>
											<td data-th="작성자">{post.createdBy}</td>
											<td data-th="작성일">{post.createdDate}</td>
										</tr>
									))}
							</tbody>
						</Table>

						{pagingInfo.totalCount > 0 && (
							<Pagination
								innerClass="gs-pagination"
								// itemClass="pg-item"
								linkClass="btn"
								itemClassFirst="pg-arrow pg-first"
								itemClassPrev="pg-arrow pg-prev"
								itemClassNext="pg-arrow pg-next"
								itemClassLast="pg-arrow pg-last"
								firstPageText={null} // 첫 번째 페이지 탐색 버튼의 텍스트
								prevPageText={null} // 이전 페이지 탐색 버튼의 텍스트
								nextPageText={null} // 다음 페이지 탐색 버튼의 텍스트
								lastPageText={null} // 마지막 페이지 탐색 버튼의 텍스트
								activePage={page} // 현재 페이지
								totalItemsCount={pagingInfo.totalCount} // 총 아이템 갯수
								itemsCountPerPage={10} // 한 페이지랑 보여줄 아이템 갯수
								pageRangeDisplayed={screenSize.width >= 480 ? 5 : 3} // paginator의 페이지 범위 (useScreenSize custom hook 사용)
								onChange={handlePageChange} // 페이지 변경을 핸들링하는 함수
							/>
						)}
					</div>
				</div>
			</Container>

			{toggleModal.modal?.name === 'file-download-dialog' && (
				<Modal ariaLabelledby="file-download-dialog" handleOpenModal={toggleModal.close} className="dialog">
					<Modal.Header>첨부파일 다운로드</Modal.Header>
					<Modal.Body>
						<div className="gs-files-con">
							<ul className="gs-files">
								{mdFiles?.map(f => <li><DownloadLink name={f.name} uid={f.uid} /></li>)}
							</ul>
						</div>
					</Modal.Body>
				</Modal>
			)}
		</main>
	);
}
